import React, { useEffect } from 'react';
import { SponsoredComponent } from '@marty-js/design/src/molecules/sponsored-component';
import { ItemSidebarComponentSponso } from '../types';
import { toSponsoredComponentProps } from '../../../utils/componentReducer';

const Sponso: React.FC<ItemSidebarComponentSponso> = ({ data, setIsIamSticky }) => {
  useEffect(() => {
    setIsIamSticky?.(false);
  }, [setIsIamSticky]);

  const props = toSponsoredComponentProps(data);

  if (!props) {
    return null;
  }

  return <SponsoredComponent {...props} />;
};

export default Sponso;
